import React, {Component} from "react";
import './Main.css'
import MyPhoto from '../assets/vesko.jpeg'


//*******************
// to build: "npm run build"
//deploy to site : run : "firebase deploy --only hosting"

//************
class Main extends Component {

    render() {
        return (
            <section className="Main" id={"section2"}>
                    <img className={"img"} src={MyPhoto} />
                    <h1 style={{color:"white"}}>Vesko Latchev</h1>
                    <h3 className={"about"} >
                        Hey my name is Vesko, I am a passionate Android developer.
                        <br/> eager to learn and grow in the field I love the most.
                    </h3>
            </section>
        )
    }
}

export default Main
